import { createContext, useContext } from 'react';

export const BrowserBarOpenContext = createContext<boolean>(true);

export function useIsBrowserBarOpen(): boolean {
  return useContext(BrowserBarOpenContext);
}
